import React from 'react'

const BottomSpace = ({ className, class: legacyClassName }) => {
    return (
        <div className={className || legacyClassName || "bottom-space"}>
            
        </div>
    )
}

export default BottomSpace
